export var SyncSignal;
(function (SyncSignal) {
    SyncSignal[SyncSignal["Response"] = 1] = "Response";
    SyncSignal[SyncSignal["StatusChanged"] = 2] = "StatusChanged";
})(SyncSignal || (SyncSignal = {}));
